import {Component, OnInit, ViewChild} from '@angular/core';
import {MatSort, Sort} from '@angular/material/sort';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {FormControl} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {TableControl} from '../../../../../common/models/TableControl';
import {DateUtil} from '../../../../../common/util/DateUtil';
import {PagedRequestDTO} from '../../../../../common/models/PagedRequestDTO';
import {DisplayIcon} from 'src/app/modules/common/components';
import {DrugInteractionDTO} from '../../../../models/DrugInteractionDTO';
import {DrugInteractionService} from '../../../../services/drug-interaction.service';
import {
  ConfirmationDialogComponent
} from '../../../../../common/dialogs/confirmation-dialog/confirmation-dialog.component';
import {detailsExpand} from '../../../../../common';
import {createFieldMap, getSortDirection} from '../../../../../common/util/Util';
import {SharedService} from '../../../../../common/services/shared-service';
import {EntityTable} from '../../../../../common/types/entity-table.enum';

@Component({
  selector: 'app-drug-interactions',
  templateUrl: './drug-interactions.component.html',
  styleUrls: [
    '../../../../../../../styles/global/_management-styles.scss'
  ],
  animations: [detailsExpand]
})
export class DrugInteractionsComponent implements OnInit {
  readonly DisplayIcon = DisplayIcon;

  drugInteractionFormControl: FormControl;
  drugInteractionDataSource: DrugInteractionDTO[];
  drugInteractionDisplayedColumns: string[] = [
    'icons',
    'interactionId',
    'drugInteractionCategoryA',
    'drugInteractionCategoryB',
    'documentation',
    'management',
    'onset',
    'severity'
  ];
  drugInteractionTableControl: TableControl;
  drugInteractionExpandedRow: DrugInteractionDTO | null;


  isConfirmed = false;
  dateFormat = DateUtil.dateFormat;
  dateTimeFormat = DateUtil.dateTimeFormat;
  length = 100;
  pageSize = 10;
  pageNumber = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];

  @ViewChild('matSort', {static: false}) tableSort: MatSort;
  @ViewChild('drugInteractionSort', {static: false}) drugInteractionSort: MatSort;
  @ViewChild('drugInteractionPaginator', {static: false}) drugInteractionPaginator: MatPaginator;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private sharedService: SharedService,
    private drugInteractionService: DrugInteractionService,
  ) {
    this.drugInteractionFormControl = new FormControl('');
    this.drugInteractionTableControl = new TableControl(
      this.length,
      this.pageSize,
      this.pageNumber,
      this.pageSizeOptions,
      'interactionId',
      'desc',
      'interactionId',
      ''
    );

  }

  ngOnInit(): void {
    this.getListOfDrugInteractions(this.drugInteractionTableControl);
  }

  getListOfDrugInteractions(tableControl: TableControl): void {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblDrugInteraction;
    pagedRequestDTO.pageNumber = tableControl.pageNumber;
    pagedRequestDTO.pageSize = tableControl.pageSize;
    pagedRequestDTO.sortField = tableControl.sortField;
    pagedRequestDTO.sortDirection = getSortDirection(
      tableControl.sortDirection
    );
    pagedRequestDTO.fieldMap = createFieldMap(
      tableControl.filterField,
      tableControl.filterValue
    );

    this.drugInteractionService.getListOfDrugInteractions(pagedRequestDTO).subscribe(
      (response) => {
        this.drugInteractionDataSource = response.resultList;
        this.drugInteractionTableControl.length = response.totalRecords;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }


  pageChanged($event: PageEvent) {
    this.drugInteractionTableControl.pageNumber = $event.pageIndex;
    this.drugInteractionTableControl.pageSize = $event.pageSize;
    this.getListOfDrugInteractions(this.drugInteractionTableControl);

  }

  sortData($event: Sort) {
    if (this.drugInteractionPaginator != null) {
      this.drugInteractionPaginator.firstPage();
    }
    this.drugInteractionTableControl.pageNumber = 0;
    this.drugInteractionTableControl.sortField = $event.active;
    this.drugInteractionTableControl.sortDirection = $event.direction;
    this.getListOfDrugInteractions(this.drugInteractionTableControl);
  }

  filterData(filterField: string) {
    if (this.drugInteractionPaginator != null) {
      this.drugInteractionPaginator.firstPage();
    }
    this.drugInteractionTableControl.pageNumber = 0;
    this.drugInteractionTableControl.filterField = filterField;
    this.drugInteractionTableControl.filterValue = this.drugInteractionFormControl.value;
    this.getListOfDrugInteractions(this.drugInteractionTableControl);
  }

  deleteEntry(event: MouseEvent, id: number) {
    event.preventDefault();
    event.stopPropagation();

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '40vw',
      data: 'Are you sure you wish to delete this entity?'
    });

    dialogRef.afterClosed().subscribe((result) => {
      const isConfirmed = result;

      if (isConfirmed) {
        this.drugInteractionService.deleteDrugInteraction(id).subscribe(
          () => {
            this.sharedService.openSnackBar(`Drug Interaction ${id} deleted`, 'Dismiss');
            this.getListOfDrugInteractions(this.drugInteractionTableControl);
          },
          (errorResponse) => {
            const error = errorResponse.error;
            this.sharedService.openErrorDialog(error.businessMessage);
          }
        );
      }
    });
  }

  editEntry(event: MouseEvent, id: number) {
    event.preventDefault();
    event.stopPropagation();

    this.router.navigate(['/pharmacy-management/edit-drug-interaction/' + id]);
  }
}
